export enum FormEsasFilledByEnum {
    PATIENT = 'patient',
    CAREGIVER = 'caregiver',
    MEDIC = 'medic',
}
